import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DtBrowserModule } from '@ithinkdt/shared/browser';
import { TranslateModule } from '@ngx-translate/core';

import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { BaseTableComponent } from './base-table/base-table.component';
import { TableEmptyContentComponent } from './table-empty-content/table-empty-content.component';

import { TableResizableDirective } from './table-resize.directive';

import { ColorLumpPipe } from './color-lump.pipe';
import { HollowColorLumpPipe } from './hollow-color-lump.pipe';

const TABLE_COMPONENTS = [BaseTableComponent, TableEmptyContentComponent];
const TABLE_DIRECTIVES = [TableResizableDirective];
const TABLE_PIPES = [ColorLumpPipe, HollowColorLumpPipe];

@NgModule({
  imports: [
    FormsModule,
    TranslateModule,
    CommonModule,
    DtBrowserModule,

    NzTableModule,
    NzPaginationModule,
    NzToolTipModule,
    NzCheckboxModule,
    NzRadioModule,
    NzIconModule,
  ],
  declarations: [...TABLE_COMPONENTS, ...TABLE_DIRECTIVES, ...TABLE_PIPES],
  exports: [...TABLE_COMPONENTS, ...TABLE_DIRECTIVES],
})
export class DtTableModule {}
